export const isIOS = (): boolean =>
    /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

export const isAndroid = (): boolean => /Android/.test(navigator.userAgent);
